import { DocumentArrowDownIcon } from "@/icons/outline";
import { format } from "date-fns";
import { connect } from "react-redux";
import { Actions as PAYMENTACTIONS } from "../../store/actions/paymentActions";
import { Link } from "react-router-dom";
import { ArrowDownOnSquareIcon } from "@heroicons/react/24/solid";

const BillingRow = ({ bill, payPeriodDetails, downloadInvoice, isAdmin, selectCredit, hasPendingBills, toggleTransactionHistoryModal }) => {
	const type = bill.type == "Credit";

	const periodDetails =
		payPeriodDetails &&
		payPeriodDetails[0] &&
		(payPeriodDetails[0].payPeriods == 12
			? format(new Date(payPeriodDetails[0].year, payPeriodDetails[0].period - 1), "LLLL") +
			  " Pay, " +
			  payPeriodDetails[0].year
			: "Pay " + payPeriodDetails[0].period + ", " + payPeriodDetails[0].year);

	return (
		<tr id={bill.id}>
			{isAdmin && hasPendingBills && (
				<td>
					{bill.billingStatus == "Pending" && (
						<label
							className="css-input switch switch-sm switch-success"
							style={{ margin: 0 }}
						>
							<input
								id="form-control form-input"
								name="select"
								className="checkbox-toggle"
								checked={bill.selected}
								onClick={() => selectCredit(bill.id)}
								type="checkbox"
								autoComplete="off"
							/>
							<span />
						</label>
					)}
				</td>
			)}
			<td>{format(new Date(bill.date), "dd MMMM yyyy")}</td>
			<td className={type ? "text-success" : "text-danger"}>
				{type ? "+" : "-"}
				{bill.credits}
			</td>
			<td>{bill.balance}</td>
			<td>
				{(type && (
					<>
						{bill?.description ?? `Credit Purchase`}
						{bill?.description == "Credit Revaluation" ? (
							<>
								&nbsp;
								<a
									className="btn btn-success btn-xs"
									href="https://www.buddy.hr/blog/pricing-update-jan-2022"
								>
									what is this?
								</a>
							</>
						) : (
							``
						)}
						{bill.invoiceNo != null ? (
							<>
								{` - ${bill.invoiceNo} `}
								<span
									className="btn btn-default btn-xs"
									onClick={() => downloadInvoice(bill.id)}
								>
									<DocumentArrowDownIcon
										className="h-5 w-5"
										style={{ verticalAlign: "middle" }}
									/>
								</span>
							</>
						) : (
							""
						)}
					</>
				)) ||
					bill?.description ||
					periodDetails}
			</td>
			{isAdmin && bill?.madeby == "SystemCharge" && !type && (
				<td style={{ width: "5%" }}>
					<button
						className="btn btn-xs btn-default pull-left"
						onClick={() => {
							toggleTransactionHistoryModal(true, bill);
						}}>
						<ArrowDownOnSquareIcon
							className="h-5 w-5 text-dark-gray"
							style={{ marginTop: "3px" }}
						/>
					</button>
				</td>
			)}
		</tr>
	);
};

const mapStateToProps = (state) => {
	return {
		isAdmin: state?.my?.profile?.isAdmin,
	};
};

const mapDispatchToProps = (dispatch) => ({
	downloadInvoice: (creditId) => dispatch(PAYMENTACTIONS.downloadInvoice(creditId)),
	selectCredit: (creditId) => dispatch(PAYMENTACTIONS.selectCredit(creditId)),
	toggleTransactionHistoryModal: (status, transaction) => dispatch(PAYMENTACTIONS.toggleTransactionHistoryModal(status, transaction)),
});

export default connect(mapStateToProps, mapDispatchToProps)(BillingRow);
